import React, { useEffect, useState } from "react";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import PendingIcon from "@mui/icons-material/Pending";
import ErrorIcon from "@mui/icons-material/Error";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningIcon from "@mui/icons-material/Warning";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { InputAdornment, TextField } from "@mui/material";
import TodayIcon from "@mui/icons-material/Today";
import SendIcon from "@mui/icons-material/Send";
import { SCDocumentacionModalCondicionado } from "./SCDocumentacionModalCondicionado";


export const CargarDocumentacionVendedor = ({
  folio,
  setLoader,
  loader,
  upload,
}) => {
  const [data, setData] = useState({
    estado: {},
    documentacion: [],
  });
  const [documentoselect, setDocumentoSelect] = useState({});
  const [compromiso, setCompromiso] = useState("");
  const [habilitarFecha, setHabilitarFecha] = useState("");
  const [comentariosCondicion, setComentariosCondicion] = useState("");
  const [checkedDocuments, setCheckedDocuments] = useState([]);
  const onChange = (prop, value, sbool, smensaje) => {
    setComentariosCondicion(value);
  };
  useEffect(() => {
    onObtenerAnalisisDocumentacion();
    onObtenerFechaCompromiso();
  }, []);
  const onObtenerAnalisisDocumentacion = () => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`ACDocumentacion/GetAsesorCondicionado?folio=${folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setData({
          estado: result.estado,
          documentacion: result.documentacion,
        });
        setCheckedDocuments(
          result.documentacion.reduce(
            (acc, doc) => ({
              ...acc,
              [doc.iddocumento]: {
                folio: folio,
                enviar_revision: doc.tiene_documentacion, // Establece el valor de checked según tiene_documentacion
                iddocumento: doc.iddocumento,
                documento: doc.documento,
                fecha_compromiso: "", // Asegúrate de inicializar la fecha de compromiso
                tiene_documentacion: doc.tiene_documentacion,
              },
            }),
            {}
          )
        );
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  };
  const onObtenerFechaCompromiso = () => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`SCFechaCompromiso/Obtener?folio=${folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        const fecha = result.fecha_compromiso.split("T")[0];
        setCompromiso(fecha);
        // setHabilitarFecha(result.habilitar_fecha);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  };

  const OnGetIcon = ({ icon }) => {
    switch (icon) {
      case "wait":
        return <PendingIcon className="wait" />;
      case "success":
        return <CheckCircleIcon className="success" />;
      case "warning":
        return <WarningIcon className="warning" />;
      case "error":
        return <ErrorIcon className="error" />;
      default:
        <></>;
    }
  };

  const onImprimirArchivo = (iddocumento) => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `SolicitudCreditoDocumentacion/ObtenerDocumento?folio=${folio}&iddocumento=${Number(
          iddocumento
        )}`
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = result.comentarios;
        const downloadLink = document.createElement("a");
        const fileName = `${result.documento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  };
  const openModal = (documento, iddocumento) => {
    var modal = document.getElementById("modal-documentos");
    modal.style.display = "block";
    setDocumentoSelect({
      documento,
      iddocumento,
    });
  };

  //Imprime el pedido Generado cuando aun no se a cargado las firmas
  const onImprimirPedidoMaquinaria = (item) => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`PedidoImpresion/ReportePDF?folio=${folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = `data:application/pdf;base64, ${result.documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${result.nombredocumento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("Clientes", JSON.stringify(error), "error");
      });
  };
  const onImprimirPagare = () => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`Pagares/ImprimirPagare?folio=${folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        if (result.length > 0) {
          result.forEach((documento, index) => {
            const linkSource = `data:application/pdf;base64, ${documento.documento}`;
            const downloadLink = document.createElement("a");
            const fileName = `${documento.nombredocumento}-${index + 1}.${documento.extension
              }`; // Añade el número de documento al nombre del archivo
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
          });
        } else {
          Swal.fire(
            "Clientes",
            "No se encontraron documentos para descargar",
            "info"
          );
        }
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("Clientes", JSON.stringify(error), "error");
      });
  };

  const onModalComentarios = () => {
    Swal.fire({
      title: "Agregar Comentario",
      input: "textarea",
      inputPlaceholder: "Escribe un comentario...",
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Enviar",
    }).then((result) => {
      if (result.isConfirmed) {
        // Aquí puedes manejar lo que sucede cuando se confirma el modal.
        const comentarios = result.value === undefined || result.value === null || result.value === ''
          ? 'Enviado a Revisión' : result.value;
        onGuardar(comentarios);
      }
    });
  };

  const onGuardar = (comentarios) => {
    setLoader({ ...loader, mostrar: true });

    const post = {
      comentarios,
      detalle: Object.values(checkedDocuments).map((doc) => ({
        folio: folio,
        iddocumento: doc.iddocumento,
        enviar_revision: doc.enviar_revision,
        fecha_compromiso: doc.fecha_compromiso
          ? doc.fecha_compromiso
          : undefined,
        tiene_documentacion: doc.tiene_documentacion,
        documento: doc.documento,
      })),
    };
    request
      .post(`SCFechaCompromiso`, post)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });

       
        onObtenerAnalisisDocumentacion()
        upload(folio);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  };

  // const handleVencimientoChange = (event) => {
  //     setCompromiso(event.target.value); // Actualiza el estado del vencimiento
  // };

  const handleCheckboxChange =
    (id, documento, tiene_documentacion) => (event) => {
      setCheckedDocuments((prevCheckedDocuments) => ({
        ...prevCheckedDocuments,
        [id]: {
          folio: folio,
          enviar_revision: event.target.checked,
          iddocumento: id,
          documento,
          fecha_compromiso: "",
          tiene_documentacion,
        },
      }));
    };

  const handleVencimientoChange = (id) => (event) => {
    const newCompromiso = event.target.value;
    setCheckedDocuments((prevCheckedDocuments) => ({
      ...prevCheckedDocuments,
      [id]: {
        ...prevCheckedDocuments[id],
        fecha_compromiso: newCompromiso,
      },
    }));
  };
  // const allDocumentsChecked = data.documentacion.length > 0 && data.documentacion.every(doc => checkedDocuments[doc.iddocumento]?.checked);

  const onDescargarPedido = () => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`PedidoImpresion/ReportePDF?folio=${folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = `data:application/pdf;base64, ${result.documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${result.nombredocumento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("Clientes", JSON.stringify(error), "error");
      });
  };
  const onDocumentoCargado = (iddocumento) => {
    var documentacion = data.documentacion.map((item) => {
      if (item.iddocumento === iddocumento) item.tiene_documentacion = true;
      return item;
    });

    setData({ ...data, documentacion });
    // setCheckedDocuments(checkdocumentos)
  };

  const onDocumentoCargadoCheck = (iddocumento) => {
    // Convertir el objeto en un array
    const updatedDocuments = Object.values(checkedDocuments).map((item) => {
      if (item.iddocumento === iddocumento) {
        // Actualizar el campo tiene_documentacion
        return { ...item, tiene_documentacion: true };
      }
      return item;
    });

    // Convertir el array de nuevo en un objeto
    const updatedDocumentsObject = updatedDocuments.reduce((acc, doc) => {
      acc[doc.iddocumento] = doc;
      return acc;
    }, {});

    // Actualizar el estado
    setCheckedDocuments(updatedDocumentsObject);
  };

  const onDescargarPagare = () => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`Pagares/ImprimirPagare?folio=${folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        if (result.length > 0) {
          result.forEach((documento, index) => {
            const linkSource = `data:application/pdf;base64, ${documento.documento}`;
            const downloadLink = document.createElement("a");
            const fileName = `${documento.nombredocumento}-${index + 1}.${documento.extension
              }`; // Añade el número de documento al nombre del archivo
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
          });
        } else {
          Swal.fire(
            "Clientes",
            "No se encontraron documentos para descargar",
            "info"
          );
        }
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("Clientes", JSON.stringify(error), "error");
      });
  };

  return (
    <div className="analisis-solicitud-credito-proceso">
      <SCDocumentacionModalCondicionado
        folio={folio}
        documento={documentoselect.documento}
        iddocumento={documentoselect.iddocumento}
        loader={loader}
        setLoader={setLoader}
        setdocumento={setDocumentoSelect}
        setdocumentos={onObtenerAnalisisDocumentacion}
        cargar={true}
        onCargarDocumento={onDocumentoCargado}
        onDocumentoCargadoCheck={onDocumentoCargadoCheck}
      />
      <div className="">
        {data.documentacion === undefined ||
          data.documentacion === null ||
          data.documentacion.length === 0 ? (
          <div></div>
        ) : (
          <div>
            <div className="cargar-documentacion-vendedor-header-container">
              <div className="cargar-documentacion-vendedor-header-descargar-documentos">
                <div
                  className="cargar-documentacion-vendedor-header-descargar-pedido"
                  onClick={() => onDescargarPedido()}
                >
                  <CloudDownloadIcon /> Descargar pedido original
                </div>
                <div
                  className="cargar-documentacion-vendedor-header-descargar-pagare"
                  onClick={() => onDescargarPagare()}
                >
                  <CloudDownloadIcon /> Descargar pagare original
                </div>
              </div>
              {data.estado.estado !== "A" && data.estado.habilitar === true && (
                <div
                  className="cargar-documentacion-vendedor-header-enviar-validacion"
                  onClick={() => onModalComentarios()}
                >
                  Enviar a validación <SendIcon />
                </div>
              )}
            </div>
            <div className="cargar-documentacion-vendedor-container">
              <div className="cargar-documentacion-vendedor-container-tabla-documentos scroll-4">
                <table cellPadding={0} cellSpacing={0}>
                  <thead>
                    <tr>
                      <th colSpan={3}>DOCUMENTOS</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.documentacion.map((doc) => (
                      <tr>
                        {data.estado.estado !== "A" ? (
                          <td>
                            {data.estado.habilitar === true && (
                              <div className="chk-groups">
                                <input
                                  type="checkbox"
                                  checked={
                                    checkedDocuments[doc.iddocumento]
                                      ?.enviar_revision || false
                                  }
                                  onChange={handleCheckboxChange(
                                    doc.iddocumento,
                                    doc.documento,
                                    doc.tiene_documentacion
                                  )}
                                  name="chk-adr"
                                />
                              </div>
                            )}
                          </td>
                        ) : (
                          <td></td>
                        )}

                        <td>{doc.documento}</td>
                        <td>
                          {doc.tiene_documentacion === true && (
                            <div
                              onClick={() => onImprimirArchivo(doc.iddocumento)}
                            >
                              <CloudDownloadIcon />
                            </div>
                          )}
                        </td>
                        {data.estado.estado === "A" &&
                          data.estado.estado === false ? (
                          <td colSpan={2}>{doc.comentarios}</td>
                        ) : doc.habilitar === false ? (
                          <>
                            <td className="update-documento-analisis"></td>
                            <td className="analianalisis-solicitud-credito-procesos-comentarios">
                              <OnGetIcon icon={doc.icono} />
                              {doc.comentarios}
                            </td>
                          </>
                        ) : checkedDocuments[doc.iddocumento]
                          ?.enviar_revision || (data.estado.estado === 'A' && doc.habilitar === true) ? ( // Verifica el estado del checkbox específico
                          <>
                            <td className="update-documento-analisis">
                              <div
                                onClick={() =>
                                  openModal(doc.documento, doc.iddocumento)
                                }
                              >
                                <CloudUploadIcon />
                                Cargar
                              </div>
                            </td>
                            <td>
                              {doc.tiene_documentacion === false && (
                                <div className="textfield-decha-compromiso">
                                  <TextField
                                    fullWidth
                                    size="small"
                                    label="Fecha para completar documentación"
                                    // disabled={
                                    //   habilitarFecha === "D" ? true : false
                                    // }
                                    variant="outlined"
                                    className="fecha"
                                    InputProps={{
                                      startAdornment: (
                                        <InputAdornment position="start">
                                          <TodayIcon fontSize="small" />
                                        </InputAdornment>
                                      ),
                                    }}
                                    type="date"
                                    value={
                                      checkedDocuments[doc.iddocumento]
                                        ?.fecha_compromiso || ""
                                    }
                                    onChange={handleVencimientoChange(
                                      doc.iddocumento
                                    )} // Asigna el manejador del evento
                                  />
                                </div>
                              )}
                            </td>
                          </>
                        ) : (
                          <>
                            <td></td>
                            <td></td>
                          </>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
